<template>
  <div
    v-if="manager"
    class="personal-manager">
    <div
      v-if="!support"
      class="personal-manager__personal-title">
      {{ $t('Common.PersonalManager') }}:
    </div>
    <div class="personal-manager__card">
      <div class="personal-manager__manager">
        <UserIcon
          v-if="!support"
          class="mr-2"
          :name="manager.fullName || ''"
          size="32"
          :src=" manager.avatar || ''"/>
        <span class="my-auto">  {{ $t(manager.fullName) }} {{ support ? ':' : '' }} </span>
      </div>
      <sPopover
        v-if="manager.email"
        :content="manager.email"
        :disabled="!hidden_email"
        trigger="hover">
        <div
          ref="email"
          slot="reference"
          class="personal-manager__email">
          {{ manager.email }}
        </div>
      </sPopover>
      <div
        v-if="manager.phones"
        class="personal-manager__phones">
        <div
          v-for="(phone, n) in manager.phones"
          :key="n">
          {{ phone }}{{ manager.phones.length > 1 && n + 1 != manager.phones.length ? ',' : '' }}
        </div>
      </div>
      <div class="flex">
        <sButton
          class="personal-manager__btn"
          color="#808686"
          :href="'mailto:' + manager.email"
          icon="mail"
          small
          type="text"/>
        <sButton
          class="personal-manager__btn"
          color="#808686"
          :href="'tel:+' + manager.phone"
          icon="phone"
          small
          type="text"/>
        <sTooltip
          :content="$t('Common.Viber')">
          <sButton
            class="personal-manager__btn"
            color="#808686"
            :href="manager.viber.includes('viber') ? manager.viber : 'viber://chat?number=' + manager.viber"
            icon="viber"
            small
            type="text"/>
        </sTooltip>
        <sTooltip
          :content="$t('Common.Telegram')">
          <sButton
            class="personal-manager__btn"
            color="#808686"
            :href="manager.telegram.includes('telegram') ? manager.telegram : 'https://telegram.me/' + manager.telegram"
            icon="telegram"
            small
            type="text"/>
          {{ $t('Common.Telegram') }}
        </sTooltip>
      </div>
    </div>
  </div>
</template>

<script>
import UserIcon from 'components/header/UserIcon.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'managerCard',
  data() {
    return {
      loading: false,
      hidden_email: false
    }
  },
  created() {
    this.loading = true
    this.$store.dispatch('personalManagerContacts')
      .finally(() => {
        this.loading = false
        this.$nextTick(() => this.hidden_email = this.$refs.email?.scrollWidth > this.$refs.email?.offsetWidth)
      })
  },
  watch: {
    currentOrganization( ) {
      this.$store.dispatch('personalManagerContacts')
    },
  },
  computed: {
    ...mapGetters({
      currentOrganization: 'getCurrentOrganization',
    }),
    manager() {
      return this.$store.getters.getPersonalManagerContacts || this.$store.getters.getSupport
    },
    support() {
      return this.manager.email == 'info@smarttender.biz'
    },
  },
  components: {
    UserIcon,
  }
}
</script>
<style lang="scss">
.personal-manager {
  &__personal-title,
  &__manager,
  &__email,
  &__phones {
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &__personal-title {
    color: var(--text-color);
    padding: 16px 16px 0 16px;
    display: flex;
    letter-spacing: 0.0125em;
    font-size: 14px;
    line-height: 18px;
    font-weight: 700;
  }
  &__card {
    padding-bottom: 8px;
    opacity: 0.7;
    padding: 10px 10px 0px;
    font-size: 14px;
    line-height: 18px;
    font-weight: 600;
  }
  &__manager {
    margin-bottom: 8px;
    display: flex;
  }
  &__email {
    text-transform: lowercase;
  }
  &__btn {
    margin-right: 4px;
    padding-top: 7px !important;
    svg {
      min-width: 16px !important;
      min-height: 16px !important;
      max-width: 16px !important;
      max-height: 16px !important;
    }
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
